var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-8",
    transform: "translate(-1304, -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1304, 95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#E3E3E3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 8)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97693819,7.22439381 C7.84809554,7.06657119 7.64959077,6.98431135 7.44628746,7.00248521 C7.24395656,7.02161526 7.06357587,7.141179 6.96718942,7.32100517 L0.0735431337,20.097064 C-0.05052784,20.3266246 -0.0152154636,20.6097616 0.161346418,20.8020049 C0.279692843,20.9311318 0.443835656,21 0.611833926,21 C0.693912662,21 0.776944267,20.9837393 0.855204194,20.9493057 L13.6326991,15.3730026 C13.8083082,15.2964824 13.9381061,15.1415296 13.9829643,14.9559736 C14.02782,14.7694553 13.9829643,14.5724176 13.8617568,14.424152 L7.97693819,7.22439381 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45225218,4.48448254 C9.64990076,5.07542839 9.6143683,5.7189075 9.35231786,6.29485299 C9.22573419,6.57324513 9.42338277,6.87664499 9.79536495,6.97166148 C9.87087,6.99166552 9.94859796,7 10.0252145,7 C10.3205887,7 10.5970596,6.86080606 10.6981139,6.63909521 C11.0478954,5.87059889 11.0956226,5.01293258 10.8313606,4.22452824 C10.5681987,3.43603855 9.98634196,2.69756428 9.1946504,2.14327649 C8.90817352,1.94240185 8.45733771,1.9540714 8.19087272,2.16994854 C7.92326784,2.38498924 7.938814,2.72340416 8.22640517,2.92342317 C8.82045099,3.33850422 9.2557378,3.89362417 9.45338353,4.48373785 L9.45225218,4.48448254 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5561151,12.0078515 C14.2341678,12.0244285 13.9851833,12.3352539 14.0006864,12.7009823 C14.015279,13.0667107 14.2879852,13.3505885 14.6108431,13.3319427 C15.8512126,13.2677062 17.1207671,13.8188821 18.0054278,14.8093645 C18.119432,14.9368005 18.2671837,15 18.4158412,15 C18.5663269,15 18.716822,14.933692 18.8317181,14.8031475 C19.0579031,14.5420584 19.0560796,14.1224561 18.826246,13.8654993 C17.7144781,12.6191211 16.1211316,11.9228871 14.5579743,12.0068065 L14.5561151,12.0078515 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3041999,6.88768617 C13.4299253,6.96352129 13.5747352,7 13.7172978,7 C13.9429312,7 14.1651966,6.90976409 14.3055206,6.73985204 C15.2967258,5.53608408 15.8827071,4.12387337 15.998317,2.65528825 C16.0252582,2.31642747 15.7255373,2.02364429 15.3292851,2.00155161 C14.9319064,1.97755293 14.5906516,2.23481975 14.5648168,2.57367561 C14.4671561,3.81777068 13.9709903,5.01387133 13.1313166,6.03330434 C12.9023152,6.31072832 12.9808943,6.69374987 13.3041884,6.88958579 L13.3041999,6.88768617 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5858787,10 C16.6279902,10 16.671932,9.99396385 16.7149575,9.98068506 C17.9160341,9.6257847 19.150155,9.48813874 20.3840415,9.56904514 C20.7117655,9.59439623 20.9827518,9.26241976 20.9992271,8.83628282 C21.0157054,8.41014897 20.766701,8.04678093 20.4435446,8.02505549 C19.1033071,7.93572469 17.7622729,8.0854139 16.4576107,8.47170953 C16.1417686,8.56587062 15.9431281,8.97871888 16.0145365,9.39521072 C16.0758722,9.75496299 16.3175593,9.99879475 16.5857802,9.99879475 L16.5858787,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7603946,3 L18.2396054,3 C18.6590086,3 19,3.41940324 19,3.76039459 L19,5.23960541 C19,5.65900865 18.6590086,6 18.2396054,6 L16.7603946,6 C16.3409914,6 16,5.58059676 16,5.23960541 L16,3.76039459 C16,3.34099135 16.3409914,3 16.7603946,3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6211633,8.00190694 C12.4551287,7.9890565 12.2881073,8.04144693 12.160618,8.15018254 L11.2227279,8.94690391 C10.9568701,9.17327005 10.9242577,9.57263536 11.150581,9.83852125 L11.9471424,10.7765997 C12.0726557,10.9238858 12.2505462,11 12.4294208,11 C12.5737122,11 12.7199719,10.9505756 12.8385808,10.849748 L13.7764709,10.0530267 C13.9039627,9.94429105 13.9840135,9.7890893 13.9978504,9.62204707 C14.0116867,9.45498965 13.9583183,9.28892421 13.8496045,9.16140932 L13.0530431,8.2233309 C12.9443293,8.09581347 12.7891587,8.01574657 12.62215,8.00190694 L12.6211633,8.00190694 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,12.0003564 C21,13.3332145 19,13.3332145 19,12.0003564 C19,10.6665479 21,10.6665479 21,12.0003564",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C12.551419,2 13,1.55144334 13,1 C13,0.448581042 12.5514433,0 12,0 C11.4485567,0 11,0.448556661 11,1 C11,1.55141896 11.4485567,2 12,2 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIconBlue);
export default __webpack_public_path__ + "static/media/events-icon--blue.e86b9b0175e2367f598e4d09dab739ee.svg";
export { ForwardRef as ReactComponent };